import { Form, Divider } from 'antd';

import CheckboxMultiSelect from '@/components/CheckboxMultiSelect';
import HeaderWithHelp from '@/components/HeaderWithHelp';
import useTripInclusionsExclusions from '@/hooks/useTripInclusionsExclusions';
import TripService from '@/services/TourServices/TripService';
import CreateSection from '@/components/CreateInclExclSection';

const question = 'What is this?';
const answer = 'Lorem ipsum dolor sit amet...';

const Exclusions = ({ initialExclusions }) => {
    const { data, mutate } = useTripInclusionsExclusions();

    return (
        <div className="exclusions">
            <HeaderWithHelp
                title="Exclusions"
                question={question}
                answer={answer}
            />

            <Divider />

            <Form.Item name="exclusions">
                <CheckboxMultiSelect
                    options={data?.data.exclusions}
                    labelParamName="name"
                    valueParamName="id"
                    initialCheckedList={initialExclusions}
                />
            </Form.Item>

            <CreateSection
                data={data}
                mutate={mutate}
                buttonText="Add New Exclusion Item"
                addNewItem={TripService.addNewExclusion}
                tourcategory={1}
            />
        </div>
    );
};

export default Exclusions;
